import { A } from '../actions/collections';
import update from 'immutability-helper';

const initialState = {
  getCollections: {
    isFetching: false,
    error: null,
  },
  getCollectionById: {
    isFetching: false,
    error: null,
  },
  saveCollection: {
    isFetching: false,
    error: null,
  },
  editCollection: {
    isFetching: false,
    error: null,
  },
  removeCollection: {
    isFetching: false,
    error: null,
  },
  addCollectionImage: {
    isFetching: false,
    error: null,
  },
  removeCollectionImage: {
    isFetching: false,
    error: null,
  },
  getCatalogs: {
    isFetching: false,
    error: null,
  },
  updateCatalog: {
    isFetching: false,
    error: null,
  },
  getCollectionFilters: {
    isFetching: false,
    error: null,
  },
  updateCollectionFilter: {
    isFetching: false,
    error: null,
  },
  data: [],
  catalogs: [],
};

const items = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_COLLECTIONS:
      return update(state, {
        getCollections: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_COLLECTIONS:
      return update(state, {
        getCollections: {
          isFetching: { $set: false },
        },
        data: { $set: action.data },
      });

    case A.ERROR_GET_COLLECTIONS:
      return update(state, {
        getCollectionById: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_COLLECTION_BY_ID:
      return update(state, {
        getCollectionById: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_COLLECTION_BY_ID:
      return update(state, {
        getCollectionById: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_COLLECTION_BY_ID:
      return update(state, {
        getCollectionById: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_SAVE_COLLECTION:
      return update(state, {
        saveCollection: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_SAVE_COLLECTION:
      return update(state, {
        saveCollection: {
          isFetching: { $set: false },
        },
        data: { $push: [action.collection] },
      });

    case A.ERROR_SAVE_COLLECTION:
      return update(state, {
        saveCollection: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EDIT_COLLECTION:
      return update(state, {
        editCollection: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EDIT_COLLECTION:
      return update(state, {
        editCollection: {
          isFetching: { $set: false },
        },
        data: {
          $apply: (i) =>
            i.map((item) => {
              if (item.id !== action.collection.id) return item;
              return action.collection;
            }),
        },
      });

    case A.ERROR_EDIT_COLLECTION:
      return update(state, {
        editCollection: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REMOVE_COLLECTION:
      return update(state, {
        removeCollection: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REMOVE_COLLECTION:
      return update(state, {
        removeCollection: {
          isFetching: { $set: false },
        },
        data: { $apply: (i) => i.filter((item) => item.id !== action.id) },
      });

    case A.ERROR_REMOVE_COLLECTION:
      return update(state, {
        removeCollection: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_COLLECTION_IMAGE:
      return update(state, {
        addCollectionImage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_COLLECTION_IMAGE:
      return update(state, {
        addCollectionImage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_COLLECTION_IMAGE:
      return update(state, {
        addCollectionImage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REMOVE_COLLECTION_IMAGE:
      return update(state, {
        removeCollectionImage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REMOVE_COLLECTION_IMAGE:
      return update(state, {
        removeCollectionImage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REMOVE_COLLECTION_IMAGE:
      return update(state, {
        removeCollectionImage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_CATALOGS:
      return update(state, {
        getCatalogs: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_CATALOGS:
      return update(state, {
        getCatalogs: {
          isFetching: { $set: false },
        },
        catalogs: { $set: action.data },
      });

    case A.ERROR_GET_CATALOGS:
      return update(state, {
        getCatalogs: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_CATALOG:
      return update(state, {
        updateCatalog: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_CATALOG:
      return update(state, {
        updateCatalog: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_CATALOG:
      return update(state, {
        updateCatalog: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_COLLECTION_FILTERS:
      return update(state, {
        getCollectionFilters: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_COLLECTION_FILTERS:
      return update(state, {
        getCollectionFilters: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_COLLECTION_FILTERS:
      return update(state, {
        getCollectionFilters: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_COLLECTION_FILTER:
      return update(state, {
        updateCollectionFilter: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_COLLECTION_FILTER:
      return update(state, {
        updateCollectionFilter: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_COLLECTION_FILTER:
      return update(state, {
        updateCollectionFilter: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default items;
